import { State } from '../State';
import * as Fate from '../fate';
import * as Level from '../level';
import * as Visit from '../visit';
import { DaycareId, daycareUnlockLevel } from './daycare.ruleset';

type UnavailableReason = 'dead' | 'visit' | 'locked';
export type AvailabilityResult =
  | { isAvailable: false; reason: UnavailableReason }
  | { isAvailable: true };

/**
 * Helper method to check for daycare status effect
 * Note - this should remain purely a proxy function; any additional business
 * logic regarding "being in daycare" should be included or made available to
 * the Fate module so that it can correctly update the fate schedule
 */
export const isInDaycare = (state: State, now: number) =>
  Fate.getters.hasPermanentStatusEffect(state, 'daycare', now);

/**
 * Check if the daycare feature has been unlocked
 */
export function isUnlocked(state: State): boolean {
  return Level.getters.getCurrentLevel(state) >= daycareUnlockLevel;
}

/**
 * Check if the daycare feature is available
 */
export const isAvailable = (state: State, now: number): AvailabilityResult => {
  const isVisiting = Visit.getters.isVisiting(state);
  const petState = Fate.getters.getVisiblePetState(state, now);

  let unavailableReason: UnavailableReason | undefined = undefined;
  if (petState === 'dead') {
    unavailableReason = 'dead';
  } else if (isVisiting) {
    unavailableReason = 'visit';
  } else if (!isUnlocked(state)) {
    unavailableReason = 'locked';
  }

  if (unavailableReason) {
    return { isAvailable: false, reason: unavailableReason };
  }

  return { isAvailable: true };
};

export function getDaycareId(): DaycareId {
  return 'd_daycare_6h';
}
